import { SettingsSection } from "components/Settings/SettingsSection";
import { useFetchGetV2 } from "hooks/fetch/useFetchGetV2";
import { Link } from "react-router-dom";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import ProgressIndicatorContainer from "components/ProgressIndicatorContainer";
import PerfectScrollbar from "react-perfect-scrollbar";
import { styled } from "@mui/material/styles";
import { useLoadCounter } from "hooks/useLoadCounter";

export function EntitlementManagementSection() {
  const {
    loading: entitlementsLoading,
    error: entitlementsError,
    response: entitlements = []
  } = useFetchGetV2("settings/entitlements");
  const tableLoadCounter = useLoadCounter(entitlementsLoading);

  return (
    <>
      <SettingsSection title="Entitlements">
        <EntitlementsTableContainer component={Paper}>
          <ProgressIndicatorContainer
            loading={entitlementsLoading}
            error={entitlementsError}
          >
            <PerfectScrollbar>
              <EntitlementsTable stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell data-col={1}>ID</TableCell>
                    <TableCell data-col={2}>Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody
                  data-qa_loading={entitlementsLoading}
                  data-qa_load_count={tableLoadCounter}
                >
                  {entitlements.map(entitlement =>
                    entitlement ? (
                      <TableRow key={entitlement.id}>
                        <TableCell data-col={1}>{entitlement.id}</TableCell>
                        <TableCell data-col={2}>
                          <Link
                            to={`/pages/settings/entitlement/${entitlement.id}`}
                          >
                            {entitlement.name}
                          </Link>
                        </TableCell>
                      </TableRow>
                    ) : null
                  )}
                </TableBody>
              </EntitlementsTable>
            </PerfectScrollbar>
          </ProgressIndicatorContainer>
        </EntitlementsTableContainer>
      </SettingsSection>
    </>
  );
}

const EntitlementsTableContainer = styled(TableContainer)`
  height: 325px;
`;
const EntitlementsTable = styled(Table)`
  height: max-content;
`;
